import { SimplifiedTableColumnDef } from '../../../../simplified-table';

export const entityTableNoComplianceExtraColumnDefs: SimplifiedTableColumnDef[] =
  [
    {
      name: 'common.table.column.filledCompliance.label',
      type: 'flags',
      columnFlags: [
        {
          path: 'filledCompliance',
          label: 'environments.table.flag.filledCompliance.label',
          tooltip: 'environments.table.flag.filledCompliance.tooltip',
          expression: 'alwaysTrue',
          severity: 'success',
        },
      ],
      globalFilter: false,
    },
  ];

export const entityTableComplianceExtraColumnDefs: SimplifiedTableColumnDef[] =
  [
    {
      column: '__complianceStatus',
      name: 'common.table.column.filledCompliance.label',
      type: 'flag-fn',
      globalFilter: false,
      featuredFilter: {
        // type: 'SELECT',
        type: 'SELECT',
        optionsPlaceholder:
          'common.table.column.filledCompliance.featuredFilter.optionsPlaceholder',
        defaultLabelSummary:
          'common.table.column.filledCompliance.featuredFilter.defaultLabelSummary',
        filterLabel:
          'common.table.column.filledCompliance.featuredFilter.filterLabel',
        options: [
          {
            label: 'enums.complianceStatus.options.PENDING',
            value: 'PENDING',
            labelSummary: 'enums.complianceStatus.options.PENDING',
          },
          {
            label: 'enums.complianceStatus.options.YES',
            value: 'YES',
            labelSummary: 'enums.complianceStatus.options.YES',
            defaultSelected: true,
          },
          {
            label: 'enums.complianceStatus.options.NO',
            value: 'NO',
            labelSummary: 'enums.complianceStatus.options.NO',
          },
        ],
      },
      options: [
        {
          label: 'enums.complianceStatus.options.PENDING',
          value: 'PENDING',
          severity: 'warn',
        },
        {
          label: 'enums.complianceStatus.options.YES',
          value: 'YES',
          severity: 'success',
        },
        {
          label: 'enums.complianceStatus.options.NO',
          value: 'NO',
          severity: 'danger',
        },
      ],
    },
  ];
